import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { PublicMobileMenu } from '@/components/PublicMobileMenu';

const routeFor = (role) => role === 'admin' ? '/admin' : role === 'teacher' ? '/teacher' : role === 'principal' ? '/principal' : role === 'director' ? '/director' : role === 'minister' ? '/minister' : '/grades';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [bad, setBad] = useState({});
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate(routeFor(user.role)); }, [user, navigate]);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const b = {};
    if (!username.trim()) b.u = true;
    if (!password.trim()) b.p = true;
    setBad(b);
    if (Object.keys(b).length) { setErr('يرجى إدخال اسم المستخدم وكلمة المرور'); return; }
    setErr('');
    setLoading(true);
    const result = await login(username.trim(), password);
    setLoading(false);
    if (result.success) {
      navigate(routeFor(result.user?.role));
    } else {
      setErr(result.error || 'بيانات الدخول غير صحيحة');
      setBad(result.status === 401 ? { u: true, p: true } : {});
    }
  };

  return (
    <div className="lgpage" dir="rtl">
      {/* Header matching the provided design */}
      <header className="nav public-page-header" data-testid="public-page-header">
        <Link to="/" className="logo" data-testid="logo-link">RasheedGPT</Link>
        <ul className="public-desktop-navigation" data-testid="public-desktop-navigation">
          <li><Link to="/" data-testid="public-desktop-link-home">الرئيسية</Link></li>
          <li><Link to="/founder" data-testid="public-desktop-link-founder">المؤسس</Link></li>
          <li><Link to="/how-it-works" data-testid="public-desktop-link-how-it-works">كيف يعمل</Link></li>
          <li><Link to="/subscribe" data-testid="public-desktop-link-subscribe">اشترك معنا</Link></li>
          <li><Link to="/feedback" data-testid="public-desktop-link-feedback">رأيك يهمنا</Link></li>
          <li><Link to="/login" className="lg cur" aria-current="page" data-testid="login-nav-active">تسجيل الدخول</Link></li>
        </ul>
        <PublicMobileMenu />
      </header>

      <main>
        {/* Login card */}
        <section className="card" data-testid="login-card">
          <span className="badge">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1l11 11-11 11L1 12z" /></svg>
            تسجيل الدخول
          </span>
          <h1>مرحبا بك في <span>رشيد</span></h1>
          <p className="sub">سجل دخولك للوصول إلى منصتك التعليمية</p>

          <form onSubmit={handleSubmit}>
            <label htmlFor="u"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-7 8-7s8 3 8 7" /></svg>اسم المستخدم</label>
            <input id="u" autoComplete="username" className={bad.u ? 'bad' : ''} value={username} onChange={(e) => setUsername(e.target.value)} placeholder="أدخل اسم المستخدم" data-testid="username-input" disabled={loading} />

            <label htmlFor="pw"><svg viewBox="0 0 24 24"><rect x="4" y="10" width="16" height="11" rx="3" /><path d="M8 10V7a4 4 0 018 0v3" /></svg>كلمة المرور</label>
            <div className="fw">
              <input id="pw" type={showPw ? 'text' : 'password'} autoComplete="current-password" className={`pw${bad.p ? ' bad' : ''}`} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="أدخل كلمة المرور" data-testid="password-input" disabled={loading} />
              <button type="button" className={`ey${showPw ? ' on' : ''}`} onClick={() => setShowPw((s) => !s)} aria-label={showPw ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'} data-testid="toggle-password">
                <svg viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" /><circle cx="12" cy="12" r="3" /></svg>
              </button>
            </div>

            <div className="er" role="alert" data-testid="login-error">{err}</div>

            <button type="submit" className="go" disabled={loading} data-testid="login-submit-button">
              {loading ? <><span className="sp"></span> جارٍ التحقق</> : 'تسجيل الدخول'}
            </button>
          </form>

          <div className="spt">
            للحصول على اسم مستخدم وكلمة مرور خاصة بك يرجى التواصل مع<br />
            <a href="mailto:support@rasheedgpt.com" data-testid="support-email-link">
              <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 8l9 6 9-6" /></svg>
              support@rasheedgpt.com
            </a>
          </div>
        </section>

        {/* Stage */}
        <section className="stage" aria-hidden="true">
          <i className="a a1"></i><i className="a a2"></i>
          <div className="ph"><img alt="" src="/login_kids.png" /></div>
          <span className="st">أهلًا بعودتك</span>
          <span className="fc" style={{ '--c': '#dd5f7a', '--d': '0s', left: '-11%', top: '24%' }}>📖</span>
          <span className="fc" style={{ '--c': '#6b4fd8', '--d': '.8s', right: '-12%', top: '38%' }}>🎯</span>
          <span className="fc" style={{ '--c': '#e0a21b', '--d': '1.6s', left: '-13%', top: '58%' }}>📝</span>
          <span className="fc" style={{ '--c': '#2e7d4f', '--d': '2.4s', right: '-10%', top: '72%' }}>👨‍👩‍👧</span>
        </section>
      </main>
    </div>
  );
};

export default LoginPage;
